import React, { useEffect, useState } from "react";
import AboutHero from "../components/aboutnv/AboutHero";
import AboutSectionsn from "../components/aboutnv/AboutSections";
import FeaturesSection from "../components/aboutnv/FeaturesSection";
import StatsSectionn from "../components/aboutnv/StatsSection";
import WhyChooseSectionn from "../components/aboutnv/WhyChooseSection";
import LazySectionAbout from "../components/aboutnv/useAboutLazySection";
import { getAboutFeature, getAboutSection, getAboutsHero, getAboutStart, getAboutWhy } from "../api/about/abouthook";

const About = () => {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // fetchAboutAll().then(res => {
    //   setHero(res.hero);
    // });
     const fetchAll = async () => {
          try {
            const [heroData ] = await Promise.all([  getAboutsHero() ]);
    
             //  const [  heroData ] = await  getAboutsHero() ;
            setHero(heroData);
           
          } catch (err) {
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
    
        fetchAll();
  }, []);

  if (!hero) return <p>Loading hero...</p>;

  return (
    
    <main>

      {/* Hero loads instantly */}
      <AboutHero data={hero} />

      {/* Section lazy-load */}
      <LazySectionAbout apiFunc={getAboutSection}>
        {(data: any) => <AboutSectionsn data={data} />}
      </LazySectionAbout>

      <LazySectionAbout apiFunc={getAboutStart}>
        {(data: any) => <StatsSectionn data={data} />}
      </LazySectionAbout>
       
       {/*Bluprint removed as per client suggestion on 28-11=25*/}
     
    {/*  <LazySectionAbout apiFunc={getAboutFeature}>
        {(data: any) => <FeaturesSection data={data} />}
      </LazySectionAbout>*/}

      <LazySectionAbout apiFunc={getAboutWhy}>
        {(data: any) => <WhyChooseSectionn data={data} />}
      </LazySectionAbout>

    </main>
  );
};

export default About;